import React, { useEffect } from 'react';
import { Switch, Route, Redirect, HashRouter, BrowserRouter } from 'react-router-dom';
import AddSubject from '../pages/addSubject/AddSubiect';
import EditSubject from '../pages/subjectBind/editSubject';
import Login from '../pages/login/Login';
import Home from '../pages/home/Home';
import Activity from '../pages/activity/Activity';
import ProjectList from '../pages/projectList/projectList';
import PrivateRoute from './AuthGuard';
import SubjectsDetail from '../pages/subjectsDetail/subjectsDetail';
import ReportRecord from '../pages/reportRecord/reportRecord';
import reportAgainTip from '../pages/reportAgainTip/reportAgainTip';
import reportTip from '../pages/reportTip/reportTip';
import SubjectBindType from '../pages/subjectBindType/subjectBindType';
import ScaleIframe from '../pages/scaleIframe/scaleIframe';
import SubjectsDetailComment from '../pages/subjectsDetailComment/subjectsDetailComment';
import NotFound from '../pages/notFound/notFound';
import ServerError from '../pages/serverError/serverError';
import CheckSubject from '../pages/checkSubject/checkSubject';
import VisitForm from '../pages/visitForm/visitForm';
import FindDetails from '../pages/findList/details/details';
import PassWord from '../pages/findList/passWord/passWord';
import PhoneNumber from '../pages/findList/phoneNumber/phoneNumber';
import CreateAccount from '../pages/findList/createAccount/createAccount';
import AffirmComponent from '../pages/findList/affirm/affirm';
import DiseasesComponent from '../pages/findList/diseases/diseases';
import AgreeComponent from '../pages/findList/comm/agree/agree';
import Authorization from '../pages/findList/comm/authorization/authorization';
import JumpToWxMini from '../pages/jumpToWxMini/jumpToWxMini';
import MainMenuHome from '../pages/menuHome/menuHome';

// doctor
import LaborService from '../pagesDoctor/laborService/laborService';
import LaborAgreement from '../pagesDoctor/laborService/laborAgreement';
import PaySheet from '../pagesDoctor/paySheet/paySheet';
import PaySheetDetail from '../pagesDoctor/paySheet/paySheetDetail';
import Settlement from '../pagesDoctor/settlementMange/settlement';
import SettlementDetail from '../pagesDoctor/settlementMange/settlementDetail';
import Personal from '../pagesDoctor/personal/personal';
import PersonalInfo from '../pagesDoctor/personal/personalInfo/personalInfo';
import BankInfo from '../pagesDoctor/personal/bankInfo/bankInfo';
import CollaborativeNew from '../pagesDoctor/collaborativeNew/collaborativeNew';
import TumorChannel from '../pagesDoctor/tumorChannel/tumorChannel';
import BrainHealthStudio from '../pagesDoctor/brainHealthStudio/brainHealthStudio';
import CollaborativeDetails from '../pagesDoctor/collaborativeDetails/collaborativeDetails';
import DoctorHome from '../pagesDoctor/home/home';
import DoctorMenu from '../pagesDoctor/menuHome/menuHome';
import DoctorTools from '../pagesDoctor/doctorTools';
import HomeScale from '../pagesDoctor/home/homeScale';
import ResetPassword from '../pagesDoctor/resetPassword/resetPassword';
import ResetNewPwd from '../pagesDoctor/resetPassword/resetNewPwd';
import ResetPwdComplete from '../pagesDoctor/resetPassword/resetPwdComplete';
import Privacy from '../pagesDoctor/privacy/privacy';
import PatientHome from '../pagesDoctor/patient/patientHome/patientHome';
import OutComeRegister from '../pagesDoctor/patient/patientHome/outComeRegister';
import CrfPage from '../pagesDoctor/crfPage/crfPage';
import AddPatient from '../pagesDoctor/patient/addPatient';
import PatientHomeDetail from '../pagesDoctor/patient/patientHome/patientHomeDetail';
import VideoCollect from '../pagesDoctor/videoCollect/videoCollect';
import CaseCollect from '../pagesDoctor/videoCollect/caseCollect';
import RwdDetail from '../pagesDoctor/videoCollect/rwdDetail';
import CRFContent from '../pages/CrfContent/CrfContent';

// medical live
import MedicalLive from '../pagesMedicalLive/menuHome/menuHome';
import MedicalLiveDetail from '../pagesMedicalLive/medicalLiveDetail';
 

// 联合塞尔项目
import UnitedSere from '../pagesUnitedSere/menuHome/menuHome';
import UnitedSereDetail from '../pagesUnitedSere/unitedSereDetail';


import SubjectLaborAgreement from '../pages/laborAgreement/laborAgreement';

// 辉瑞项目
import PfizerRegister from '../pagesPfizer/register';
import PfizerDoctorComplete from '../pagesPfizer/doctor/doctorComplete';
import PfizerAssistantComplete from '../pagesPfizer/assistant/assistantComplete';
import PfizerAuditComplete from '../pagesPfizer/auditComplete';
import PfizerDoctorAssistantGroup from '../pagesPfizer/doctor/assistantGroup';
import PfizerDoctorAssistantGroupDetail from '../pagesPfizer/doctor/assistantGroupDetail';
import PfizerAssistantHome from '../pagesPfizer/assistant/workbench';
import PfizerAssistantAllDoctors from '../pagesPfizer/assistant/allDoctors';
import PfizerAssistantAddDoctor from '../pagesPfizer/assistant/addDoctor';
import PfizerAssistantProjectDetail from '../pagesPfizer/assistant/projectDetail';
import PfizerDoctorApplyList from '../pagesPfizer/doctor/applyList';
import PfizerDoctorApplyListDetail from '../pagesPfizer/doctor/applyListDetail';
import PfizerPersonalInfo from '../pagesPfizer/personalInfo/personalInfo';
import PfizerPatientHome from '../pagesPfizer/patient/home/index';
import PfizerPatientCreate from '../pagesPfizer/patient/createRecord';

// ae
import AeChat from '../pagesAE/AeChat/index';
import AeChatReport from '../pagesAE/AeChat/report';
import AeMenuHome from '../pagesAE/AeMenuHome/index';
import AeHomepage from '../pagesAE/AeHome/index';
import AeCalendar from '../pagesAE/AeCalendar/calendar';
import AlkRemindCalendar from '../pagesAE/AlkRemindCalendar/remindCalendar';
import AeReport from '../pagesAE/AeReport/index';
import AeReporting from '../pagesAE/AeReporting/index';
import AlkReportDetail from '../pagesAE/AlkReport/detail';
import AeReportRecord from '../pagesAE/AlkReport/record';
import AePointsMall from '../pagesAE/AePointsMall/index';
import AePointsRecords from '../pagesAE/AePointsRecords/index';
import AePersonal from '../pagesAE/AePersonal/index';
import AeTestTools from '../pagesAE/AeTestTools/index';
import AeTestDetail from '../pagesAE/AeTestDetail/index';
import AlkReportOld from '../pagesAE/AlkReport/index';
import AlkReport from '../pagesAE/AlkReport/alkReport';
import AlkReportResult from '../pagesAE/AlkReport/result';
import AeScale from '../pagesAE/AeScale/index';
import AlkTestReord from '../pagesAE/AlkTestReord/index';
import AlkCommonAsk from '../pagesAE/AlkCommonAsk/index';
import AlkCommonAskDetail from '../pagesAE/AlkCommonAskDetail/index';
import AlkPrivacy from '../pagesAE/AlkPrivacy/index';
import AlkPrivacyUserAgreement from '../pagesAE/AlkPrivacy/privacy/privacy';
import UploadToOss from '../component/uploadToOss/uploadToOss';
import AlkAutoJumpScale  from '../pagesAE/AeAutoScale/index';

// CSO doctor
import CSOMenuHome from '../pagesCSO/menuHome/menuHome';
import CSOSearch from '../pagesCSO/search/index';
import CSOMenuUnderHome from '../pagesCSO/menuUnder/menuHome';
import CSODoctorInfo from '../pagesCSO/home/doctorInfo/index';
import CovidSuggest from '../pagesCSO/home/covidSuggest/index';
import MultiMedicineList from '../pagesCSO/home/multiMedicineList/index';
import MultiMedicineDetail from '../pagesCSO/home/multiMedicineDetail/index';
import MoreCureSuggest from '../pagesCSO/home/moreCureSuggest/index';
import CSOGuide from '../pagesCSO/guide/index';
import CSOCure from '../pagesCSO/tools/index';
import CSODoctorFeedback from '../pagesCSO/feedback';
import CSOPersonalCenter from '../pagesCSO/personalCenter';
import CSOPrivacy from '../pagesCSO/CSOPrivacy/index';
import CSOPatientPrivacyUserAgreement from '../pagesCSO/CSOPrivacy/privacy/privacy';
import CSODoctorPrivacyUserAgreement from '../pagesCSO/CSOPrivacy/doctorPrivacy/doctorPrivacy';
import CSOPatientDetail from '../pagesCSO/patient/patientDetail';
// ePro patient
import EPROPatientSignAgreement from '../pagesEPROPatient/signAgreement';
import EPROPatientConfirmInvit from '../pagesEPROPatient/confirmInvit';
import EPROPatientHome from '../pagesEPROPatient/home';
import EPROPatientWelcome from '../pagesEPROPatient/home/welcome';
import EPROPatientHomeRecord from '../pagesEPROPatient/home/record';
import EPROPatientReportSurvey from '../pagesEPROPatient/home/reportSurvey';
import EPROPatientReportResult from '../pagesEPROPatient/home/reportResult';
import EPROPatientTourist from '../pagesEPROPatient/tourist';
import EPROPatientEvaluation from '../pagesEPROPatient/evaluation';
import EPROPatientEvaluationResult from '../pagesEPROPatient/evaluationResult';
import EPROPJumpToWxMini from '../pagesEPROPatient/jumpToWxMini/jumpToWxMini';
// CSO patient
import CSOPatientMenuHome from '../pagesCSOPatient/menuHome/menuHome';

import TransferUrlLink from '../pagesTransfer/pagesTransfer';
import SignAgreement from '../pages/signAgreement';
import JunHome from '../pagesJun/home';
import JunTermsOfService from '../pagesJun/terms-of-service';
import JunProfile from '../pagesJun/profile';
import JunPatient from '../pagesJun/patient';
import JunInvitation from '../pagesJun/invitation';

const RouterView = (props: any) => {

    return (
        <HashRouter>
            <Switch>
                <PrivateRoute path='/' exact component={Login} />
                {/* 君实患管项目 新版页面 */}
                <Redirect path="/v2" exact to="/v2/home"/>
                <PrivateRoute path="/v2/home" exact component={JunHome}/>
                <PrivateRoute path="/v2/patient" exact component={JunPatient}/>
                <PrivateRoute path="/v2/profile" exact component={JunProfile}/>
                <PrivateRoute path="/v2/invitation" exact component={JunInvitation}/>
                <PrivateRoute path="/v2/terms-of-service" exact component={JunTermsOfService}/>

                <PrivateRoute path='/home' component={Home} />
                <PrivateRoute path='/projectList' component={MainMenuHome} />
                {/* <PrivateRoute path='/projectList' component={ProjectList} /> */}
                <Route path='/login' component={Login}></Route>
                <PrivateRoute path='/activity' component={Activity}></PrivateRoute>
                
                <PrivateRoute path='/addSubject' component={AddSubject} />
                <PrivateRoute path='/editSubject/:subjectCode' component={EditSubject} />
                <PrivateRoute path='/checkSubject/:id' component={CheckSubject} />
                <PrivateRoute path='/subjectsDetail/:id' component={SubjectsDetail} />
                <PrivateRoute path='/reportRecord/:scaleCode/:subjectCode' component={ReportRecord} />
                <PrivateRoute path='/reportAgainTip/:scaleCode/:subjectCode' component={reportAgainTip} />
                <PrivateRoute path='/reportTip/:subjectCode' component={reportTip} />
                <PrivateRoute path='/subjectBindType/:subjectCode' component={SubjectBindType} />
                <PrivateRoute path='/eproScaleIframe/:scaleCode/:recordId/:type' component={ScaleIframe} />
                <PrivateRoute path='/videoCollect' component={VideoCollect} />
                <PrivateRoute path='/caseCollect' component={CaseCollect} />
                <PrivateRoute path='/rwdDetail' component={RwdDetail} />
                <PrivateRoute path='/subjectsDetailComment/:id' component={SubjectsDetailComment} />
                <PrivateRoute path='/visitForm' component={VisitForm} />
                <PrivateRoute path='/findList/details/details' component={FindDetails} />
                <PrivateRoute path='/findList/passWord/passWord' component={PassWord} />
                <PrivateRoute path='/findList/phoneNumber/phoneNumber' component={PhoneNumber} />
                <PrivateRoute path='/findList/createAccount/createAccount' component={CreateAccount} />
                <PrivateRoute path='/findList/affirm/affirm' component={AffirmComponent} />
                <PrivateRoute path='/findList/comm/agree/agree/:type' component={AgreeComponent} />
                <PrivateRoute path='/findList/comm/authorization/authorization' component={Authorization} />
                <PrivateRoute path='/findList/diseases/diseases' component={DiseasesComponent} />
                <Route path='/jumpToWxMini' component={JumpToWxMini} />
                <Route exact path="/signAgreement/:subjectCode" component={SignAgreement}/>

                {/* doctor */}
                <PrivateRoute path='/doctor/laborService' component={LaborService} />
                <PrivateRoute path='/doctor/laborAgreement' component={LaborAgreement} />
                <PrivateRoute path='/doctor/paySheet' component={PaySheet} />
                <PrivateRoute path='/doctor/paySheetDetail' component={PaySheetDetail} />
                <PrivateRoute path='/doctor/personal' component={Personal} />
                <PrivateRoute path='/doctor/personalInfo' component={PersonalInfo} />
                <PrivateRoute path='/doctor/bankInfo' component={BankInfo} />
                <PrivateRoute path='/doctor/settlement' component={Settlement} />
                <PrivateRoute path='/doctor/settlementDetail/:id' component={SettlementDetail} />
                <PrivateRoute path='/doctor/patient/home' exact component={PatientHome} />
                <Route path='/doctor/homepage' component={DoctorHome} />
                <Route path='/doctor/home' exact component={DoctorMenu} />
                <Route path='/doctor/tools' exact component={DoctorTools} />
                <Route path='/doctor/homeScale' exact component={HomeScale} />
                <Route path='/doctor/resetPassword' exact component={ResetPassword} />
                <Route path='/doctor/resetNewPwd' exact component={ResetNewPwd} />
                <Route path='/doctor/resetPwdComplete' exact component={ResetPwdComplete} />
                <Route path='/doctor/privacy' exact component={Privacy} />
                <Route path='/crf' component={CrfPage} />
                <Route path='/doctor/patientHomeDetail' component={PatientHomeDetail} />
                <Route path='/doctor/addPatientManually' exact component={AddPatient} />
                <PrivateRoute path='/doctor/outComeRegister' exact component={OutComeRegister} />

                {/*  */}
                <Route path='/collaborative' component={CollaborativeNew}></Route>
                <Route path='/collaborativeDetails' component={CollaborativeDetails}></Route>
                <Route path='/tumorChannel' component={TumorChannel}></Route>
                <Route path='/brainHealthStudio' component={BrainHealthStudio}></Route>


                {/* 联合塞尔 UnitedSere */}

                <Route path='/UnitedSere' component={UnitedSere} />
                <Route path='/UnitedSereDetail/:id' exact component={UnitedSereDetail} />
                {/* 医脉通 medicallive */}

                <Route path='/medicalLive' component={MedicalLive} />
                <Route path='/medicalLiveDetail/:id' exact component={MedicalLiveDetail} />

                <Route path='/crf' component={CRFContent} />
                {/* 服务协议 */}
                <Route path='/laborAgreement' component={SubjectLaborAgreement}></Route>

                {/* 辉瑞项目 ↓ */}
                <Route path='/pfizer/register' component={PfizerRegister}></Route>
                <Route path='/pfizer/auditComplete' exact component={PfizerAuditComplete}></Route>
                <Route path='/pfizer/personalInfo' exact component={PfizerPersonalInfo}></Route>
                {/* 医生 */}
                <Route path='/pfizer/doctor/complete' exact component={PfizerDoctorComplete}></Route>
                <Route path='/pfizer/doctor/assistantGroup' component={PfizerDoctorAssistantGroup}></Route>
                <Route path='/pfizer/doctor/assistantGroupDetail' exact component={PfizerDoctorAssistantGroupDetail}></Route>
                <Route path='/pfizer/doctor/applyList' exact component={PfizerDoctorApplyList}></Route>
                <Route path='/pfizer/doctor/applyListDetail' exact component={PfizerDoctorApplyListDetail}></Route>
                {/* 医助 */}
                <Route path='/pfizer/assistant/complete' exact component={PfizerAssistantComplete}></Route>
                <Route path='/pfizer/assistant/home' exact component={PfizerAssistantHome}></Route>
                <Route path='/pfizer/assistant/allDoctors' exact component={PfizerAssistantAllDoctors}></Route>
                <Route path='/pfizer/assistant/addDoctor' exact component={PfizerAssistantAddDoctor}></Route>
                <Route path='/pfizer/assistant/projectDetail' exact component={PfizerAssistantProjectDetail}></Route>
                {/* 患者 */}
                <Route path='/pfizer/patient/home' component={PfizerPatientHome}></Route>
                <Route path='/pfizer/patient/createRecord' component={PfizerPatientCreate}></Route>
                {/* 辉瑞项目 ↑ */}

                {/* AE ↓ */}
                <Route exact path={`/ae/chart`} component={AeChat}></Route>
                <Route exact path={`/ae/chart/report`} component={AeChatReport}></Route>
                <Route exact path={`/ae/home`} component={AeMenuHome}></Route>
                <Route exact path={`/ae/homepage`} component={AeHomepage}></Route>
                <Route exact path={`/ae/calendar`} component={AeCalendar}></Route>
                <Route exact path='/ae/report' component={AeReport}></Route>
                <Route exact path='/ae/reporting' component={AeReporting}></Route>
                <Route exact path='/ae/pointsMall' component={AePointsMall}></Route>
                <Route exact path='/ae/pointsRecords' component={AePointsRecords}></Route>
                <Route exact path='/ae/personal' component={AePersonal}></Route>
                <Route exact path='/ae/testTools' component={AeTestTools}></Route>
                <Route exact path='/ae/reporting/detail' component={AlkReportDetail}></Route>
                <Route exact path='/ae/reporting/record' component={AeReportRecord}></Route>
                <Route exact path={`/alk/remindCalendar`} component={AlkRemindCalendar}></Route>
                <Route exact path='/alk/reportOld' component={AlkReportOld}></Route>
                <Route exact path='/alk/report' component={AlkReport}></Route>
                <Route exact path='/alk/reportResult' component={AlkReportResult}></Route>
                <Route exact path='/alk/testDetail' component={AeTestDetail}></Route>
                <Route exact path='/alk/scale' component={AeScale}></Route>
                <Route exact path='/alk/testReord' component={AlkTestReord}></Route>
                <Route exact path='/alk/commonAsk' component={AlkCommonAsk}></Route>
                <Route exact path='/alk/commonAsk/detail' component={AlkCommonAskDetail}></Route>
                <Route exact path='/alk/privacy' component={AlkPrivacy}></Route>
                <Route exact path='/alk/privacy/index' component={AlkPrivacyUserAgreement}></Route>
                <Route exact path='/alk/autoJumpScale' component={AlkAutoJumpScale }></Route>
                {/* AE ↑ */}

                {/* CSO ↓ */}
                {/* <Route exact path={`/cso/doctor/home`} component={CSOMenuUnderHome}></Route> */}
                <Route exact path={`/cso/doctor/home`} component={CSOMenuHome}></Route>
                <Route exact path={`/cso/doctor/search`} component={CSOSearch}></Route>
                <Route exact path={`/cso/doctor/doctorInfo`} component={CSODoctorInfo}></Route>
                <Route exact path={`/cso/doctor/covidSuggest`} component={CovidSuggest}></Route>
                <Route exact path={`/cso/doctor/multiMedicineList`} component={MultiMedicineList}></Route>
                <Route exact path={`/cso/doctor/multiMedicineDetail`} component={MultiMedicineDetail}></Route>
                <Route exact path={`/cso/doctor/moreCureSuggest`} component={MoreCureSuggest}></Route>
                <Route exact path={`/cso/doctor/guide`} component={CSOGuide}></Route>
                <Route exact path={`/cso/doctor/cure`} component={CSOCure}></Route>
                <Route exact path={`/cso/doctor/feedback`} component={CSODoctorFeedback}></Route>
                <Route exact path={`/cso/doctor/personalCenter`} component={CSOPersonalCenter}></Route>
                <Route exact path='/cso/doctor/privacy' component={CSOPrivacy}></Route>
                <Route exact path='/cso/patient/privacy/index' component={CSOPatientPrivacyUserAgreement}></Route>
                <Route exact path='/cso/doctor/privacy/index' component={CSODoctorPrivacyUserAgreement}></Route>
                <Route exact path={`/cso/patient/patientDetail`} component={CSOPatientDetail}></Route>
                <Route exact path={`/cso/patient/home`} component={CSOPatientMenuHome}></Route>
                {/* CSO ↑ */}

                {/* 中转跳转 */}
                <Route exact path={`/transfer/urllink/:code`} component={TransferUrlLink}></Route>

                {/* ePRO ↓ */}
                <Route exact path={`/epro/patient/signAgreement`} component={EPROPatientSignAgreement} ></Route>
                <Route exact path={`/epro/patient/confirmInvit`} component={EPROPatientConfirmInvit} ></Route>
                <Route exact path={`/epro/patient/home`} component={EPROPatientHome}></Route>
                <Route exact path={`/epro/patient/welcome`} component={EPROPatientWelcome}></Route>
                <Route exact path={`/epro/patient/home/record`} component={EPROPatientHomeRecord}></Route>
                <Route exact path={`/epro/patient/reportSurvey`} component={EPROPatientReportSurvey}></Route>
                <Route exact path={`/epro/patient/reportResult`} component={EPROPatientReportResult}></Route>
                <Route exact path={`/epro/patient/tourist`} component={EPROPatientTourist}></Route>
                <Route exact path={`/epro/patient/evaluation`} component={EPROPatientEvaluation}></Route>
                <Route exact path={`/epro/patient/evaluationResult`} component={EPROPatientEvaluationResult}></Route>
                <Route path='/jumpToWxMiniEpro' component={EPROPJumpToWxMini} />
                {/* ePRO ↑ */}

                <Route exact path='/uploadToOss' component={UploadToOss}></Route>

                <PrivateRoute path='/notFound' component={NotFound} />
                <Route path='/serverError' component={ServerError}></Route>

                {/* <Route path='*' component={NotFound}></Route> */}
                {/* <Redirect to='/home'></Redirect> */}
            </Switch>
        </HashRouter>
    )
}

export default RouterView;